import { render, staticRenderFns } from "./ShowDocument.vue?vue&type=template&id=4e49fe0d&"
import script from "./ShowDocument.vue?vue&type=script&lang=js&"
export * from "./ShowDocument.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports